import { SvgIcon, SvgIconProps } from '@mui/material';

const PaypalIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Paypal">
          <g id="Vector">
            <path
              d="M12.4242 4.80862C12.5801 3.79258 12.4242 3.11523 11.8788 2.48998C11.2815 1.78657 10.1906 1.5 8.78812 1.5H4.76242C4.47673 1.5 4.24297 1.70842 4.19103 1.99499L2.50283 12.6764C2.47686 12.8848 2.63269 13.0671 2.84047 13.0671H5.33381L5.152 14.1613C5.12603 14.3437 5.25589 14.5 5.46367 14.5H7.56743C7.82715 14.5 8.03493 14.3176 8.0609 14.0832L8.50243 11.3216C8.5284 11.0872 8.76215 10.9048 8.9959 10.9048H9.30757C11.3334 10.9048 12.9437 10.0711 13.4112 7.67435C13.593 6.68437 13.5151 5.82465 12.9956 5.2515C12.8398 5.06914 12.658 4.93888 12.4242 4.80862Z"
              fill="#009CDE"
            />
            <path
              d="M12.4242 4.80862C12.5801 3.79258 12.4242 3.11523 11.8788 2.48998C11.2815 1.78657 10.1906 1.5 8.78812 1.5H4.76242C4.47673 1.5 4.24297 1.70842 4.19103 1.99499L2.50283 12.6764C2.47686 12.8848 2.63269 13.0671 2.84047 13.0671H5.33381L5.93117 9.21142C5.98312 8.92485 6.21687 8.71643 6.50256 8.71643H7.69729C10.0348 8.71643 11.8528 7.77856 12.3723 5.01703C12.3983 4.96493 12.3983 4.88677 12.4242 4.80862Z"
              fill="#012169"
            />
            <path
              d="M6.63242 4.83467C6.6584 4.6523 6.89215 4.41784 7.1259 4.41784H10.2945C10.6581 4.41784 11.0217 4.44389 11.3334 4.49599C11.6191 4.5481 12.1385 4.67836 12.3983 4.83467C12.5541 3.81864 12.3983 3.14128 11.8528 2.51603C11.2815 1.78657 10.1906 1.5 8.78812 1.5H4.76242C4.47673 1.5 4.24297 1.70842 4.19103 1.99499L2.50283 12.6764C2.47686 12.8848 2.63269 13.0671 2.84047 13.0671H5.33381L6.63242 4.83467Z"
              fill="#003087"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default PaypalIcon;
